<template>
    <div class="login">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="register-logo" ref="porto">
                <logo />
                <div class="register-form-logo-text">
                    Конструктор корпоративного стандарта
                </div>
                <div class="pdf_file_block">
                    <a href="https://disk.yandex.ru/i/uPea2njQwqRxCQ" class="pdf_file_block_item">
                        Положение_-_отбор_КЦОП
                    </a>
                    <a href="https://disk.yandex.ru/i/17ZSOfsg4nAh9Q"  class="pdf_file_block_item">
                        Общая презентация КЦОП
                    </a>
                    <a href="https://disk.yandex.ru/i/33xmhT34M7KHzw" class="pdf_file_block_item">
                        Стандарт КЦОП
                    </a>
                </div>
            </div>
        <div class="register-wrap">
            <!--<div class="isWelcomeText">
                <b>Уважаемый пользователь!</b> <br><br>
                <b><i>Регистрация закрыта!</i></b> <br><br>
                Остались вопросы?<br> Обращайтесь к нам по указанным контактам - руководитель сети корпоративных центров опережающей подготовки Тимур Хакимов <a href="mailto:t.khakimov@worldskills.ru">t.khakimov@worldskills.ru</a>
            </div>-->
            <div class="isWelcomeText" v-show="isWelcomeText">
                <b>
                    Агентство развития профессий и навыков (Ворлдскиллс Россия) совместно с Министерством экономического развития Российской Федерации запускают отбор для предприятий, желающих открыть Корпоративный центр опережающей подготовки в 2023 году. Российским компаниям предоставлена уникальная возможность: с 29 декабря 2022 года стартует отбор заявок по новым трекам нацпроекта «Производительность труда», куратором которого является первый вице-премьер Российской Федерации Андрей Белоусов.
                </b>
                <br><br>
                
                Корпоративный центр опережающей подготовки (далее –КЦОП) – это организационно-методическая площадка внутри предприятия, которая позволяет:
                <ul>
                <li>пройти обучение командой от предприятия по методикам аудита рабочих мест и разработки корпоративных стандартов профессий;</li>
                <li>объективно оценивать компетенции сотрудников;</li>
                <li>координировать ускоренную профессиональную подготовку сотрудников по востребованным на предприятии компетенциям;</li>
                <li>разрабатывать и реализовывать короткие адресные образовательные программы;</li>
                <li>организовывать переподготовку своих работников с использованием лучших практик и методик движения Ворлдскиллс.</li>
                </ul>


                <br>
                Для того, чтобы открыть КЦОП:
                <ol>
                    <li>до 1 февраля 2023 года подайте заявку.</li>
                    <li>Найдите необходимые ресурсы (команду, готовую обучиться методикам и применять их в дальнейшем на предприятии)</li>
                    <li>Сформируйте повестку вашего КЦОП (перечень приоритетных должностей/компетенций, по которым у вас есть потребность в подготовке или переподготовке кадров)</li>
                    <li>В феврале 2023 года участвуйте в дистанционном обучении по методикам организации КЦОП</li>
                    <li>Пройдите финальный отбор по результатам обучения и защиты повестки КЦОП</li>
                    <li>Войдите в число победителей конкурсного отбора и получайте возможность помимо КЦОП получить меры поддержки в рамках прохождения аудита кадровой потребности (далее – АКП)</li>

                </ol>
                <br>
                <b>Чтобы участвовать в Проекте,</b> до 1 февраля подайте заявку <a href="#" @click="isWelcomeText=false">данном сайте</a> - 
                и получайте информации в личном кабинете об этапах конкурсного отбора! Для начала регистрации введите ИНН вашей организации «Поле ввода ИНН» Мы рекомендуем Вам скачать прилагаемые документы «Положение конкурсного отбора КЦОП», «Общая презентация КЦОП и АКП», «Стандарт КЦОП», чтобы ознакомиться с деталями и увидеть, как будет устроен весь процесс. Остались вопросы? Смело свяжитесь с нами по указанными контактам:
                
                <ol>
                    <li>Директор департамента по работе с сетью корпоративных центров опережающей подготовки Тимур Хакимов <a href="mailto:t.khakimov@worldskills.ru">t.khakimov@worldskills.ru</a></li>
                    <li>Руководитель проектов департамента по работе с сетью корпоративных центров опережающей подготовки Маргарита Цыганова <a href="mailto:m.cyganova@worldskills.ru">m.cyganova@worldskills.ru</a> </li>
                </ol>

                <br><br>
                <div class="register-button" @click="scrollToRegister()">Перейти к регистрации</div>

            </div>
            <div class="form-reg" v-show="!isWelcomeText">
                <h3>Регистрация</h3>
                    <br>
                    <div class="header-for-input first-input-header">Чтобы начать регистрацию, введите ИНН организации</div>
                    <input type="text" name="company.inn" v-model="company.inn" placeholder="Введите ИНН организации" @click="isError = false" autocomplete="OFF" />
                    <button @click="get_dadata_data()">Поиск</button>
                    <input type="text" v-show="isFieldsShow" v-model="company.full_name" @click="isError = false" autocomplete="off" placeholder="Полное наименование компании" />
                    <input type="text" v-show="isFieldsShow" v-model="company.short_name" @click="isError = false" autocomplete="off" placeholder="Короткое наименование компании" />
                    <input type="text" v-show="isFieldsShow" v-model="company.address" @click="isError = false" autocomplete="off" placeholder="Юридический адрес" />
                    <input type="text" v-show="isFieldsShow" v-model="company.okved" @click="isError = false" autocomplete="off" placeholder="Основной ОКВЭД"/>
                    <input type="text" v-show="isFieldsShow" v-model="company.count_of_emploies" @click="isError = false" autocomplete="off" placeholder="Количество сотрудников" />
                    <br>
                    <h3 v-show="isFieldsShow">Данные аккаунта</h3>
                    <input type="text" v-show="isFieldsShow" v-model="company.surname" @click="isError = false" autocomplete="off" placeholder="Фамилия" />
                    <input type="text" v-show="isFieldsShow" v-model="company.name" @click="isError = false" autocomplete="off" placeholder="Имя" />
                    <input type="text" v-show="isFieldsShow" v-model="company.third_name" @click="isError = false" autocomplete="off" placeholder="Отчество" />

                    <input type="text" v-show="isFieldsShow" v-model="company.email" @click="isError = false" autocomplete="off" placeholder="Ваш Email" />
                    <input type="password" v-show="isFieldsShow" v-model="company.password" @click="isError = false" autocomplete="off" placeholder="Пароль" />
                    <input type="text" v-show="isFieldsShow" v-model="company.phone" @click="isError = false" autocomplete="off" placeholder="Телефон" />
                    <input type="text" v-show="isFieldsShow" v-model="company.position" @click="isError = false" autocomplete="off" placeholder="Должность" />

                    <div class="register-button" v-show="isFieldsShow" @click="register()">Регистрация</div>
            </div>
        </div>
    </div>
</template>


<script>
import Logo from '@/assets/svg/logo.vue'
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'Register',
    components: {
        Logo,  Success, Error
    },
    data() {
        return {
            isError: false,
            isFieldsShow: false,
            company: {
                inn: '',
                full_name: '',
                short_name: '',
                address: '',
                okved: '',
                count_of_emploies: 0,
                email: '',
                password: '',
                phone: '',
                position:  '',
                surname: '',
                name: '',
                third_name: ''
            },
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            /* common vars */
            isWelcomeText: true,
        }
    },
    methods: {
        scrollToRegister() {
            this.isWelcomeText = false
            var element = this.$refs['porto'];
            var top = element.offsetTop;

            window.scrollTo(0, top);
        },
        get_dadata_data() {
            if(this.company.inn.length < 10) {
                this.error_text = 'ИНН должен содержать более 10 символов';
                this.isError = true;
                return
            }
            let loader = this.$loading.show()
            this.$http.defaults.headers.common['Authorization'] = 'Token ' + '709f86bbecbbcc8c794dcb848f2439833981e49d';
            this.$http.defaults.headers.common['Content-Type'] = 'application/json';
            this.$http.defaults.headers.common['Accept'] = 'application/json';
            this.$http.post('https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/party', {
            query: this.company.inn
            })
            .then(response => {
                let dadataanswer = response.data;
                if(dadataanswer.suggestions != null) {
                    this.company.full_name = dadataanswer.suggestions[0].unrestricted_value
                    this.company.short_name = dadataanswer.suggestions[0].value
                    this.company.address = dadataanswer.suggestions[0].data.address.unrestricted_value
                    this.company.okved = dadataanswer.suggestions[0].data.okved
                    this.company.count_of_emploies = dadataanswer.suggestions[0].data.employee_count
                    this.isFieldsShow = true
                }
                else {
                    this.error_text = 'Ничего не найдено, попробуйте исправить запрос';
                    this.isError = true;
                    console.log('here')
                }
                loader.hide();
            })
            .catch(error => {
                loader.hide();
                this.error_text = 'Системная ошибка при выполнении поиска: ' + error
                this.isError = true;
            });
        },
        register() {
            let loader = this.$loading.show()
            //this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.post(process.env.VUE_APP_API_URL + '/api/register_company', this.company)
                .then(response => {
                    loader.hide()
                    localStorage.setItem('token', response.data.token)
                    localStorage.setItem('admin', 1)
                    localStorage.setItem('surname', response.data.surname)
                    localStorage.setItem('name', response.data.name)
                    localStorage.setItem('email', response.data.email)
                    localStorage.setItem('user_id', response.data.id)
                    localStorage.setItem('permissions', JSON.stringify(response.data.permissions))

                    this.$router.push('/quiz')

                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
                });
        }
    },
    created() {
        console.log('Router push')
        window.location.href =  'https://kcop.worldskills.ru/register'
    }
}
</script>

<style scoped src="../assets/style/login.css"></style>
<style scoped>
    .isWelcomeText {
        font-size: 15px;
        line-height: 26px;
    }
</style>